import axios from 'axios'

export default () => {
    return axios.create({
        withCredentials: true,
        baseURL: 'https://codenote.onrender.com/folders' // In each request, append the selected folder id to the base URL
    })
}